import React from 'react';
import PageHeader from '../../components/PageHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faChartLine, faFileAlt, faBook, faUsers, faEye } from '@fortawesome/free-solid-svg-icons';
import useLocalStorage from '../../hooks/useLocalStorage';

const Dashboard = () => {
    const breadcrumbItems = [
        { label: 'Home', link: '/' },
        { label: 'Administration', link: null },
        { label: 'Dashboard', link: '/dashboard' }
    ];

    const { storedValue: user } = useLocalStorage('user', null);

    // Example statistics data (Replace with actual API data)
    const stats = {
        totalUsers: 1200,
        activeUsers: 800,
        visits: 3500,
        documents: 150,
        constitutions: 75,
        recentConstitutions: 10,
        popularSections: 25
    };

    return (
        <div className="">
            <PageHeader items={breadcrumbItems} pageTitle="Dashboard" />

            {/* Welcome Message */}
            <div className="bg-white dark:bg-gray-800  border-2 border-gray-200 dark:border-gray-600 p-5 shadow rounded-lg mt-8">
                <h2 className="text-lg font-semibold flex items-center text-gray-800 dark:text-gray-200">
                    Welcome, {user?.firstname} {user?.lastname}
                </h2>
                <p className="text-gray-600 text-sm dark:text-gray-400">
                    This is the main dashboard for your application. Here you can see the statistics of your application and the users.
                </p>
            </div>

            {/* Stats Overview */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                {/* Users */}
                <div className="bg-white border-2 border-gray-200 dark:border-gray-600 dark:bg-gray-800 p-5 shadow rounded-lg">
                    <h2 className="text-lg font-semibold flex items-center text-gray-800 dark:text-gray-200">
                        <FontAwesomeIcon icon={faUsers} className="mr-2 text-blue-500" />
                        Active Users
                    </h2>
                    <p className="text-xl font-bold text-gray-800 dark:text-gray-200">
                        {stats.activeUsers} / {stats.totalUsers}
                    </p>
                </div>

                {/* Visits */}
                <div className="bg-white border-2 border-gray-200 dark:border-gray-600 dark:bg-gray-800 p-5 shadow rounded-lg">
                    <h2 className="text-lg font-semibold flex items-center text-gray-800 dark:text-gray-200">
                        <FontAwesomeIcon icon={faChartLine} className="mr-2 text-green-500" />
                        Website Visits
                    </h2>
                    <p className="text-xl font-bold text-gray-800 dark:text-gray-200">{stats.visits}</p>
                </div>

                {/* Documents */}
                <div className="bg-white border-2 border-gray-200 dark:border-gray-600 dark:bg-gray-800 p-5 shadow rounded-lg">
                    <h2 className="text-lg font-semibold flex items-center text-gray-800 dark:text-gray-200">
                        <FontAwesomeIcon icon={faFileAlt} className="mr-2 text-yellow-500" />
                        Documents
                    </h2>
                    <p className="text-xl font-bold text-gray-800 dark:text-gray-200">{stats.documents}</p>
                </div>
            </div>

            {/* Katiba Database Insights */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                {/* Total Constitutions */}
                <div className="bg-white border-2 border-gray-200 dark:border-gray-600 dark:bg-gray-800 p-5 shadow rounded-lg">
                    <h2 className="text-lg font-semibold flex items-center text-gray-800 dark:text-gray-200">
                        <FontAwesomeIcon icon={faBook} className="mr-2 text-purple-500" />
                        Total Constitutions
                    </h2>
                    <p className="text-xl font-bold text-gray-800 dark:text-gray-200">{stats.constitutions}</p>
                </div>

                {/* Recent Additions */}
                <div className="bg-white border-2 border-gray-200 dark:border-gray-600 dark:bg-gray-800 p-5 shadow rounded-lg">
                    <h2 className="text-lg font-semibold flex items-center text-gray-800 dark:text-gray-200">
                        <FontAwesomeIcon icon={faBook} className="mr-2 text-indigo-500" />
                        Recently Added
                    </h2>
                    <p className="text-xl font-bold text-gray-800 dark:text-gray-200">{stats.recentConstitutions}</p>
                </div>

                {/* Popular Sections */}
                <div className="bg-white border-2 border-gray-200 dark:border-gray-600 dark:bg-gray-800 p-5 shadow rounded-lg">
                    <h2 className="text-lg font-semibold flex items-center text-gray-800 dark:text-gray-200">
                        <FontAwesomeIcon icon={faEye} className="mr-2 text-red-500" />
                        Most Viewed Sections
                    </h2>
                    <p className="text-xl font-bold text-gray-800 dark:text-gray-200">{stats.popularSections}</p>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
